module.exports = __webpack_public_path__ + "static/emp_handbook-0570679db16895e9a06997a374225fc7.png";